import { Component } from '@angular/core'
import { RushGameService } from '@rush-shared/services'

@Component({
  selector: 'app-win-streak',
  standalone: true,
  imports: [],
  templateUrl: './win-streak.component.html',
  styleUrl: './win-streak.component.sass',
})
export class WinStreakComponent {
  get lineBarHighLightWidth(): string {
    const percent = (this._rushGameService.winStreak / 15) * 100
    return `${percent > 100 ? 100 : percent}%`
  }

  constructor(public _rushGameService: RushGameService) {}
}
